export enum SenderType {
    Advertisement = 1,
    Service = 2,
    Awareness = 4,
    Warning = 8,
}
